import PawModel from './PawModel';

class Context extends PawModel {
  static apiType = 'contexts';

  static d3Compatible = false;

  filter: any;

  title!: string;

  parent_id!: string;
  
  level!: number;
  
  values!: any;
    
  color!: string;
    
  app_id!: string;
        
  position!: string;
    
  bsize!: number;
    
  options!: any;
    
  source!: any;
    
  user_id?: string;
}
export default Context;